module.exports = __webpack_public_path__ + "static/dubai-64be68cb0c503898385ede78fae1e700.jpg";